"use client"

import { useEffect } from "react"
import { useRouter } from "next/navigation"

export default function CareerCoachDemoPage() {
  const router = useRouter()

  useEffect(() => {
    // Redirect to partner dashboard with demo mode
    router.replace("/partner-dashboard?demo=true")
  }, [router])

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <p className="text-lg text-gray-600">Redirecting to demo...</p>
      </div>
    </div>
  )
}
